(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/client/internal/active-campaigns-data-fetcher.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/client/internal/active-campaigns-data-fetcher.js');

'use strict';

function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const {
  logger
} = svs.numbergames.campaign._internal;
const {
  processCampaignResponse
} = svs.numbergames.campaign.shared;
const {
  getProductId
} = svs.numbergames.productMapping;
var _ActiveCampaignsDataFetcher_brand = new WeakSet();
class ActiveCampaignsDataFetcher {
  constructor() {
    var _svs$numbergames$camp;
    _classPrivateMethodInitSpec(this, _ActiveCampaignsDataFetcher_brand);
    _defineProperty(this, "cache", null);
    this.cache = (_svs$numbergames$camp = svs.numbergames.campaign_cache) === null || _svs$numbergames$camp === void 0 || (_svs$numbergames$camp = _svs$numbergames$camp.data) === null || _svs$numbergames$camp === void 0 ? void 0 : _svs$numbergames$camp.campaigns;
  }
  async fetchData() {
    let {
      product
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (product) {
      if (!this.cache) {
        const apiData = await _assertClassBrand(_ActiveCampaignsDataFetcher_brand, this, _getApiData).call(this);
        if (apiData) {
          this.cache = processCampaignResponse(apiData.response);
        }
      }
      if (this.cache) {
        const productId = getProductId(product);
        return this.cache[productId];
      }
    }
    return null;
  }
  dataFromCache() {
    var _this$cache;
    let {
      product
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (_this$cache = this.cache) === null || _this$cache === void 0 ? void 0 : _this$cache[getProductId(product)];
  }
}
async function _getApiData() {
  try {
    return await svs.core.jupiter.callAsync({
      path: '/draw/1/campaigns',
      method: 'GET'
    });
  } catch (err) {
    logger.warn('Could not get campaign data from API', err);
  }
}
svs.numbergames.campaign._internal.ActiveCampaignsDataFetcher = ActiveCampaignsDataFetcher;

 })(window);